<template>
  <div class="page page-hero">
    <div class="playbook-page-content">
      <div class="playbook-page-column playbook-hero-col-1">
        <PageColumnItem
          v-for="(item, index) in page.columns[0]"
          :key="index + item.type + '-item-' + item.style"
          :item="item"
          :itemsCount="page.columns[0] ? page.columns[0].length : 0"
          :itemIndex="index"
          :pageType="'Hero'"
          :precoloredDesignShadow="page.precoloredShadow"
          :designDimension="page.precoloredDimension"
          :anonymousCrossOrigin="anonymousCrossOrigin"
          :isChromagear="page.isChromagear"
          :layoutIndex="page.layoutIndex"
          :columnIndex="index"
          :sportName='page.name'
          :readOnly="readOnly"
        />
        <MissingProduct v-if="!page.columns[0] || !page.columns[0].length"  :msg="'Missing Product/s or Hero'"/>
      </div>
      <div
        class="playbook-page-column playbook-hero-col-2"
      >
        <div class="page-title" v-if="page.header">
          <HTMLDisplay :content="page.header" />
        </div>
        <PageColumnItem
          v-for="(item, index) in page.columns[1]"
          :key="index + item.type + '-item-' + item.style"
          :item="item"
          :itemsCount="page.columns[1] ? page.columns[1].length : 0"
          :pageType="'Hero'"
          :precoloredDesignShadow="page.precoloredShadow"
          :itemIndex="index"
          :designDimension="page.precoloredDimension"
          :isChromagear="page.isChromagear"
          :columnIndex="index"
          :readOnly="readOnly"
          :sportName="page.name"
          :layoutIndex="page.layoutIndex"
        />
        <MissingProduct v-if="!page.columns[1] || !page.columns[1].length" :msg="'Missing Product/s or Hero'"/>
      </div>
    </div>
    <div class="page-number-count" :class="{ 'right-page-number': pageId % 2 === 0 }">
      {{ pageId }}
    </div>
  </div>
</template>

<script>
import HTMLDisplay from "@/components/Projects/Playbooks/HTMLDisplay.vue";
import PageColumnItem from "@/components/Projects/Playbooks/PageColumnItem.vue";
import MissingProduct from "@/components/Projects/Playbooks/MissingProduct.vue";

export default {
  name: "Hero",
  props: {
    page: {
      type: Object,
    },
    anonymousCrossOrigin: {
      type: Boolean
    },
    readOnly: {
      type: Boolean
    },
    pageId: {
      type: Number
    }
  },
  components: {
    HTMLDisplay,
    PageColumnItem,
    MissingProduct
  },
};
</script>

<style lang="scss">
#app {
  .page-hero {
    padding: 0;
    margin: 0;
    .playbook-page-content {
      justify-content: space-between;
      .playbook-page-column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 50%;
        max-height: 100%;
        &.playbook-hero-col-1 {
          width: 360px;
          max-width: 55%;
          flex: none;
        }
        &.playbook-hero-col-2 {
          width: 320px;
          max-width: 45%;
          flex: none;
        }
        .product {
          justify-content: center;
        }
      }
    }
  }
}
</style>